Apt.fn.extend('maps', {}, {
	/**
	 * Load territory geometry data
	 */
	initTerritories() {
		const scope = this;

		if (! scope.territoryReady) {
			scope.territoryReady = true;

			scope.bindPoly('territories');
		}

		scope.initSubterritories();

		if (scope.map.getZoom() >= scope.break) {
			return;
		}

		scope.getGroup('subterritories');
	},

	/**
	 * Load subterritory geometry data
	 */
	initSubterritories() {
		const scope = this;

		if (! scope.subterritoryReady) {
			scope.subterritoryReady = true;

			scope.bindPoly('subterritories');
		}

		scope.loadListings();
	}
});